<section class="mortgage">
  <h2>Mortgage payoff</h2>

  <p class="error" *ngIf="error" role="alert">{{ error }}</p>
  <p class="loading" *ngIf="loading && !error">Loading…</p>

  <ng-container *ngIf="!loading && !error">
    <div class="inputs">
      <label>
        <span>Balance owed</span>
        <input type="text" inputmode="decimal" [(ngModel)]="draft.principal"
               (input)="preview()" (change)="commit()"/>
      </label>

      <label>
        <span>APR</span>
        <input type="text" inputmode="decimal" [(ngModel)]="rateDraft"
               (input)="preview()" (change)="commit()"/>
        <em>%</em>
      </label>

      <label>
        <span>Months remaining</span>
        <input type="number" min="1" [max]="maxMonths" step="1"
               [(ngModel)]="settings.termMonths"
               (input)="preview()" (change)="commit()"/>
      </label>

      <label>
        <span>Extra each month</span>
        <input type="text" inputmode="decimal" [(ngModel)]="draft.extra"
               (input)="preview()" (change)="commit()"/>
      </label>
    </div>

    <p class="derived" *ngIf="hasLoan">
      Scheduled payment <strong>{{ fmt(paymentCents) }}</strong>
      <em>principal &amp; interest — not escrow</em>
    </p>

    <p class="empty" *ngIf="!hasLoan">
      Enter a balance to see a payoff schedule.
    </p>

    <p class="warn" *ngIf="stalled" role="alert">
      At this rate the payment doesn’t cover one month of interest, so the
      balance never falls. Check the APR and the months remaining.
    </p>

    <ng-container *ngIf="schedule.length">
      <dl class="figures">
        <div>
          <dt>Paid off</dt>
          <dd>{{ payoffDate + 'T00:00:00' | date: 'MMM yyyy' }}</dd>
        </div>
        <div>
          <dt>Total interest</dt>
          <dd>{{ fmt(totalInterestCents) }}</dd>
        </div>
        <div *ngIf="showCompare && !extraIsWhatPaysItOff">
          <dt>Months saved</dt>
          <dd>{{ monthsSaved }}</dd>
        </div>
        <div *ngIf="showCompare && !extraIsWhatPaysItOff">
          <dt>Interest saved</dt>
          <dd>{{ fmt(interestSavedCents) }}</dd>
        </div>
      </dl>

      <p class="warn" *ngIf="showCompare && extraIsWhatPaysItOff" role="alert">
        Without the extra payment this loan never pays off at all, so there’s
        nothing to compare it against — the extra payment is the only reason
        it does.
      </p>

      <!-- When extraIsWhatPaysItOff, comparePoints/compareDisplayValues are a
           zero-filled series padded to match points' length (see
           padToSameHorizon) — every year reads $0.00, which would assert the
           no-extra loan pays off immediately when it in fact never pays off.
           Withhold the compare series here so the chart's accessible data
           table omits the column instead of lying. The warning paragraph
           above already explains this state to the reader. -->
      <mm-line [points]="points"
               [displayValues]="displayValues"
               [compare]="showCompare && !extraIsWhatPaysItOff ? comparePoints : []"
               [compareDisplayValues]="showCompare && !extraIsWhatPaysItOff ? compareDisplayValues : []"
               compareLabel="Without extra"
               ariaLabel="Balance remaining"></mm-line>

      <table class="years">
        <caption>Year by year</caption>
        <thead>
          <tr>
            <th scope="col">Year</th>
            <th scope="col">Principal</th>
            <th scope="col">Interest</th>
            <th scope="col">Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let y of yearRows; trackBy: trackYear">
            <th scope="row">{{ y.year }}</th>
            <td>{{ fmt(y.principalCents) }}</td>
            <td>{{ fmt(y.interestCents) }}</td>
            <td>{{ fmt(y.balanceCents) }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
</section>
